import { useQuery } from '@apollo/client';
import { Flex } from '@chakra-ui/react';
import { Spinner } from '@chakra-ui/react';
import Button from '@components/interactive/Button';
import { getDrxAcsEndpoint } from '@utils/config';
import GET_SAML_RESPONSE_BODY from '../../gql/SAMLResponseBody';

const DRXRedirect = ({
  userId,
  isDisabled = false,
  loading = false,
  era = 'current',
  CTA = 'Shop Plans',
  samlBody = null,
  recYear,
  relayState = process.env.DRX_PREFERENCES_LANDING_PAGE,
  agentId = null,
}) => {
  const { loading: requestLoading, data } = useQuery(GET_SAML_RESPONSE_BODY, {
    skip: !!samlBody,
    nextFetchPolicy: 'no-cache',
    variables: {
      userId,
      year: parseInt(recYear),
      agentId,
    },
  });

  return (
    <>
      {!loading && !requestLoading ? (
        <Flex w="100%" align="center" justify="center" paddingBottom={8}>
          <form
            id="RedirectAuthForm"
            method="POST"
            target="_blank"
            action={getDrxAcsEndpoint(recYear)}
            style={{ width: '100%' }}
          >
            <textarea
              hidden
              id="SAMLResponse"
              name="SAMLResponse"
              value={samlBody || data?.getSAMLResponseBody?.response_body}
              readOnly
            />
            <textarea hidden id="RelayState" name="RelayState" readOnly value={relayState} />
            <Button isDisabled={isDisabled} width="100%" type="submit" id="send_to_drx">
              {CTA}
            </Button>
          </form>
        </Flex>
      ) : (
        <Flex mb="2%" w="100%" align="center">
          <Button isDisabled={isDisabled} width="100%" type="submit" id="send_to_drx">
            <Spinner thickness="3px" speed="0.65s" emptyColor="gray.200" color="blue.500" w="20px" h="20px" />
          </Button>
        </Flex>
      )}
    </>
  );
};

export default DRXRedirect;
